import React, { useState } from 'react'
import { Input } from 'reactstrap'

const arr = Array.from({ length: 6 }).map((_, i) => i + 1);

/**
 * 
 * @param {import('../types').FormV2FieldProps} param0 
 */
const CodeV2Field = ({
    value,
    onChange,
    onBlur,
    onFocus,
    isRequired,
    isDisabled,
    errorMessage,
    classes,
    styles,
    aria,
    id,
    name,
    valid,
    hasError,
    label,
    lang,
}) => {
    const [inFocus, setInFocus] = useState(false);

    return (
        <div className='formV2-field-code-wrapper'>
            <Input
                id={id}
                name={name}
                type='text'
                inputMode='numeric'
                value={value}
                onChange={e => onChange?.(e.target.value)}
                onBlur={() => {
                    setInFocus(false);
                    onBlur?.();
                }}
                onFocus={() => {
                    setInFocus(true);
                    onFocus?.();
                }}
                disabled={isDisabled}
                required={isRequired}
                invalid={hasError}
                valid={valid}
                {...aria || {}}
                className={`formV2-field-code-input ${classes?.field}`}
                style={styles?.field}
                autoComplete='one-time-code'
                aria-label={label ? undefined : 'Code'.translate(lang)}
            />
            <div className='formV2-field-code-input-box' aria-hidden>
                {arr.map(i => {
                    const num = value?.[i - 1] || '';
                    let isActive = null;
                    if (inFocus) {
                        if (i === 6 && value?.length === 6) isActive = 'formV2-field-code-input-box-active formV2-field-code-input-box-active-last'

                        if (value?.length <= 6 && value.length === i - 1) isActive = 'formV2-field-code-input-box-active'
                    }

                    return <div key={i} >
                        <div>{num}</div>
                        {isActive ? <div className={isActive}>
                            {'|'}
                        </div> : null}
                    </div>
                })}
            </div>
        </div>
    )
}

export default CodeV2Field